import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Aanvullende informatie", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Aanvullende informatie", -1)

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { issueStore } from '@/stores/issue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import SignatureField from '@/components/SignatureField.vue'
import { inProgressIssueStates } from '@/helpers/issueStates'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowSolvedAndDeniedButtons',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const showIssueReadyModal = ref(false)
const showIssueRejectedModal = ref(false)
const loading = ref({ solve: false, ready: false, reject: false })
const issueStateData = ref<{ comment:string, customerSign:boolean, signature:string|null }>({
  comment: '',
  customerSign: false,
  signature: null
})

function toggleIssueReadyModal () : void {
  showIssueReadyModal.value = !showIssueReadyModal.value

  if (showIssueReadyModal.value) {
    issueStateData.value.comment = 'Deze melding is naar behoren en tevredenheid opgelost.'
  } else {
    issueStateData.value = {
      comment: '',
      customerSign: false,
      signature: null
    }
  }
}

function markIssueAsReady () : void {
  loading.value.ready = true
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + route.params.issueId + '/ready', issueStateData.value).then(() => {
    toggleIssueReadyModal()
    notification.success({ message: 'Melding gereed gemeld.', description: 'De servicemelding is succesvol gereed gemeld.', duration: 5 })
    router.push({ name: 'Issues' })
  }).catch(() => {
    notification.error({ message: 'Melding NIET bijgewerkt!', description: 'Melding NIET bijgewerkt. Probeer het later nogmaals.', duration: 0 })
  }).finally(() => {
    loading.value.ready = false
  })
}

function markIssueAsSolved () : void {
  loading.value.solve = true
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + route.params.issueId + '/solved').then(() => {
    notification.success({ message: 'Melding gemarkeerd als opgelost.', description: 'De servicemelding is succesvol gemarkeerd als opgelost.', duration: 5 })
    router.push({ name: 'Issues' })
  }).catch(() => {
    notification.error({ message: 'Melding NIET bijgewerkt!', description: 'Melding NIET bijgewerkt. Probeer het later nogmaals.', duration: 0 })
  }).finally(() => {
    loading.value.solve = false
  })
}

function toggleIssueRejectedModal () : void {
  showIssueRejectedModal.value = !showIssueRejectedModal.value

  if (showIssueRejectedModal.value) {
    issueStateData.value.comment = 'Deze melding is afgewezen want: '
  } else {
    issueStateData.value = {
      comment: '',
      customerSign: false,
      signature: null
    }
  }
}

function markIssueAsRejected () : void {
  loading.value.reject = true
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + route.params.issueId + '/reject', issueStateData.value).then(() => {
    toggleIssueRejectedModal()
    notification.success({ message: 'Melding gemarkeerd als afgewezen.', description: 'De servicemelding is succesvol gemarkeerd als afgewezen.', duration: 5 })
    router.push({ name: 'Issues' })
  }).catch(() => {
    notification.error({ message: 'Melding NIET bijgewerkt!', description: 'Melding NIET bijgewerkt. Probeer het later nogmaals.', duration: 0 })
  }).finally(() => {
    loading.value.reject = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      type: "error",
      disabled: !_unref(inProgressIssueStates).includes(_unref(issueStore)().issue.status),
      onClick: toggleIssueRejectedModal
    }, {
      default: _withCtx(() => [
        _createTextVNode("Afgewezen")
      ]),
      _: 1
    }, 8, ["disabled"]),
    (_unref(issueStore)().issue.type === 8 && _unref(authStore)().user.id === _unref(issueStore)().issue.user.id)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "success",
          disabled: loading.value.solve,
          loading: loading.value.solve,
          onClick: markIssueAsSolved
        }, {
          default: _withCtx(() => [
            _createTextVNode("Opgelost")
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      : (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          type: "success",
          onClick: toggleIssueReadyModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Gereed")
          ]),
          _: 1
        })),
    _createVNode(_component_a_modal, {
      title: "Servicemelding gereed melden.",
      visible: showIssueReadyModal.value,
      onCancel: toggleIssueReadyModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: toggleIssueReadyModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annuleren")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: loading.value.ready,
          disabled: issueStateData.value.comment.length < 40 || loading.value.ready,
          onClick: markIssueAsReady
        }, {
          default: _withCtx(() => [
            _createTextVNode("Markeer als opgelost")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_textarea, {
                  style: {"margin-bottom":"4px"},
                  value: issueStateData.value.comment,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((issueStateData.value.comment) = $event))
                }, null, 8, ["value"]),
                _createElementVNode("span", null, "Minimaal 50 tekens. Huidig aantal tekens: " + _toDisplayString(issueStateData.value.comment ? issueStateData.value.comment.length : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, {
          class: _normalizeClass(!issueStateData.value.customerSign ? 'no-mb' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox, {
                  checked: issueStateData.value.customerSign,
                  "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((issueStateData.value.customerSign) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Klant tekent voor akkoord")
                  ]),
                  _: 1
                }, 8, ["checked"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        (issueStateData.value.customerSign)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 0,
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(SignatureField, {
                      width: "100%",
                      height: "180px",
                      returnType: "base64",
                      signatureName: "Handtekening_bewoner",
                      onSignatureSave: _cache[2] || (_cache[2] = ($event: any) => (issueStateData.value.signature = $event)),
                      onSignatureCleared: _cache[3] || (_cache[3] = ($event: any) => (issueStateData.value.signature = null))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      title: "Servicemelding afwijzen.",
      visible: showIssueRejectedModal.value,
      onCancel: toggleIssueRejectedModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: toggleIssueRejectedModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annuleren")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: loading.value.reject,
          disabled: issueStateData.value.comment.length < 40 || loading.value.reject,
          onClick: markIssueAsRejected
        }, {
          default: _withCtx(() => [
            _createTextVNode("Afwijzen")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_textarea, {
                  style: {"margin-bottom":"4px"},
                  value: issueStateData.value.comment,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((issueStateData.value.comment) = $event))
                }, null, 8, ["value"]),
                _createElementVNode("span", null, "Minimaal 50 tekens. Huidig aantal tekens: " + _toDisplayString(issueStateData.value.comment ? issueStateData.value.comment.length : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})